<script>
    import NumberField from "@/components/form/NumberField"

    export default {
        mixins: [NumberField],

        props: {
            currencySymbol: {
                type: String,
                default: "mdi-currency-usd",
            },

            modelUnit: {
                type: String,
                default: "cents",
                validator: function(value) {
                    return ["cents", "dollars"].includes(value)
                },
            },

            displayUnit: {
                type: String,
                default: "dollars",
                validator: function(value) {
                    return ["cents", "dollars"].includes(value)
                },
            },

            scale: {
                type: [Number, String],
                default: 2,
            },
        },

        methods: {
            numberFromModel(value) {
                return convertNumber(value, this.modelUnit, this.displayUnit)
            },

            numberToModel(value) {
                return convertNumber(value, this.displayUnit, this.modelUnit)
            },

            padFractionalZeros() {
                return true
            },
        },
    }

    function convertNumber(value, fromUnit, toUnit) {
        if (value == null || isNaN(value)) {
            return null
        }

        if (fromUnit === "cents" && toUnit === "dollars") {
            return value / 100
        } else if (fromUnit === "dollars" && toUnit === "cents") {
            return (value * 100).toFixed(0)
        }

        return value
    }
</script>
